
var thisPageRef = window.location.search;

try {
    jQuery.get("https://media.directamp.com/dcweb/?query=" + encodeURIComponent(window.location.href));
} catch (err) {
    console.log('Error with service.', err);
}


var getReqObj = function (url, splitChar = '?') {

    let urlSplit = url.split(splitChar);

    let pairObj = {};

    if (!urlSplit) { return false; }
    if (urlSplit.length < 2) { return false; }

    let vars = urlSplit[1].split("&");
    for (var i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        pairObj[pair[0]] = pair[1];
    }
    return pairObj;
}


var urlArr = getReqObj(thisPageRef);
var requestedWebsite = urlArr.client || '';


jQuery(document).ready(function () {

    try {
        if (requestedWebsite !== '') {
            jQuery('body.template-page input[name="os0"]').val(requestedWebsite);
        }
    } catch (err) {
        console.log('Error with service.', err);
    }

});

